export default __webpack_public_path__ + "media/images/icons_fc/tempsbleu-bd793e6fd599e892a6a61a42ff57e6dc.png";